import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getExternalCalendars } from 'api/calendar';
import ReAuthIntegrationModal from 'components/Modal/ReAuthIntegrationModal';
import useConnectModal from 'components/ConnectModal';
import { usePrefs } from 'hooks/usePrefs';
import Scheduler from '../SchedulerEditor';
import { ZapierIntegration } from './Zapier';
import IntegrationCard from './IntegrationCard';

import './integrations.scss';

const params = new URLSearchParams(window.location.search);
const isConnected = params.get('account_connected') === 'true';

const Integrations = () => {
  const location = useLocation();
  const { setConnectedModalOpen, ConnectModal } = useConnectModal();
  const { updateCalendarPrefs } = usePrefs();

  const userInfo = useSelector(state => state.global.userInfo);
  const { personas, integrations, integrationsEnabled } = userInfo || {};
  const { isOrgOwner, isOrgMember } = personas || {};
  const activeIntegration = integrations?.find(integration => integration?.grantStatus === 'valid');
  const expiredIntegration = !activeIntegration && integrationsEnabled ?
    integrations?.find(integration => integration?.grantStatus === 'expired') :
    null;

  if (location.pathname.includes('/scheduler-editor')) {
    return (<Scheduler />);
  }

  // The login calendars likely haven't been created yet since the task is delegated to a worker,
  // so we poll for them until they are returned to correctly update the preferences.
  useEffect(() => {
    if (isConnected) {
      setExternalProjectsPref(updateCalendarPrefs);
    }
    setConnectedModalOpen(isConnected);
  }, []);

  return (
    <>
      <div className="integration-list">
        {(integrationsEnabled && (isOrgOwner || isOrgMember)) && (
          <>
            <IntegrationCard />
          </>
        )}
        <ZapierIntegration />
      </div>
      <ReAuthIntegrationModal expiredIntegration={expiredIntegration} />
      <ConnectModal />
    </>

  );
};

// Polls for external calendars to update the login preferences.
const setExternalProjectsPref = async (updateCalendarPrefs) => {
  try {
    const response = await getExternalCalendars();
    if (response.ok) {
      const externalCalendars = response.data;
      // We only want external calendars that have already been committed to the login_calendars table.
      const loginCalendars = externalCalendars.filter(ec => ec.login_calendar_id);
      // exit condition.
      if (loginCalendars.length > 0) {
        const loginCalendarsById = Object.fromEntries(loginCalendars.map(lc => [lc.login_calendar_id, true]));
        updateCalendarPrefs('externalCalendarsDisplay', loginCalendarsById);
        return;
      }
    }
    setTimeout(() => setExternalProjectsPref(updateCalendarPrefs), 2000);
  } catch {
    // Just keep retrying.
    setTimeout(() => setExternalProjectsPref(updateCalendarPrefs), 2000);
  }
};

export default Integrations;
